module.exports = __webpack_public_path__ + "img/2024-09-19a_1.8bb155b1.jpg";